<template>
    <div>
        <card :header="client.nom + ' ' + (client.prenoms ?? '')">
            <template #body>
                <div>
                    <p><strong>Phone:</strong> {{ client.telephone }} <span v-if="client.telephone2"> / {{
                            client.telephone2 }}</span></p>
                    <p><strong>Adresse:</strong> {{ client.adresse }}</p>

                </div>
                <div class="row">
                    <div class="col text-end">
                        <button class="btn btn-primary float-right" @click="$router.push({name:'clients.view', params: { id: client.id }})" ><i class="bi bi-eye me-1"></i>Ouvrir</button>
                    </div>
                </div>
            </template>
        </card>
    </div>
</template>

<script>
import Card from './Card.vue'
export default {
    name: 'ClientInList',
    components: {
        Card
    },
    props: {
        client: {
            type: Object,
            required: true
        }
    }
}
</script>